import { apiClient } from './api';
import type { ApiResponse } from '@/types';

export type ChannelType = 'whatsapp' | 'webchat' | 'telegram' | 'sms' | 'email';

export interface Channel {
  id: string;
  tenant_id: string;
  type: ChannelType;
  name: string;
  status: 'connected' | 'disconnected' | 'error';
  phone_number_id: string | null;
  waba_id: string | null;
  is_default: boolean;
  metadata: Record<string, unknown>;
  created_at: string;
  updated_at: string;
}

export interface SaveWhatsAppChannelRequest {
  name: string;
  phone_number_id?: string;
  waba_id?: string;
  access_token?: string;
  verify_token?: string;
  status?: Channel['status'];
  is_default?: boolean;
}

export interface ListChannelsParams {
  tenant_id?: string;
}

export async function listChannels(params?: ListChannelsParams): Promise<ApiResponse<Channel[]>> {
  return apiClient.get<Channel[]>('/channels', params);
}

export async function getChannel(channelId: string): Promise<ApiResponse<Channel>> {
  return apiClient.get<Channel>(`/channels/${channelId}`);
}

export async function createWhatsAppChannel(payload: SaveWhatsAppChannelRequest): Promise<ApiResponse<Channel>> {
  return apiClient.post<Channel>('/channels', payload);
}

export async function updateWhatsAppChannel(channelId: string, payload: SaveWhatsAppChannelRequest): Promise<ApiResponse<Channel>> {
  return apiClient.put<Channel>(`/channels/${channelId}`, payload);
}
